<lib-page-layout>
  <lib-title-navbar pageHeader title="Twoje gierki"></lib-title-navbar>

  <div pageHeader>
    <div class="or-py-12-px segment-divider">
      <lib-my-games-segment [source]="source()" (sourceChange)="changeSource($event)"></lib-my-games-segment>
    </div>
  </div>

  @if (showPlaceholder()) {
    <div class="or-justify-content-center or-align-items-center or-d-flex or-flex-col or-h-100-pc or-px-32-px">
      <div class="or-mb-24-px or-head-sm or-text-align-center">Nie masz żadnych gierek</div>
      <button class="button-primary-style or-h-48-px or-w-100-pc or-head-md" (click)="emptyStateCta().action()">
        {{ emptyStateCta().label }}
      </button>
    </div>
  } @else {
    <div>
      @for (month of months(); track month) {
        <div class="or-ml-24-px or-head-sm or-py-12-px or-color-secondary-2">{{ month }}</div>
        @for (game of getGamesForMonth(month); track game.gameId) {
          <div class="or-mb-12-px">
            <lib-game-card-v2
              [game]="game"
              [redirectType]="game.redirectType"
              [showHostDetails]="game.redirectType === RedirectTypeEnum.GAME"
              [badgeMode]="game.redirectType === RedirectTypeEnum.GAME ? badgeMode.PLAYER : badgeMode.HOST"
              [showAddSimilarGame]="game.redirectType === RedirectTypeEnum.HOSTED"
              (onAddSimilarGameClicked)="addSimilarGame(game)">
            </lib-game-card-v2>
          </div>
        }
      }
    </div>
  }

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
